export const setAuth = uid => ({
  type: "SET_AUTH",
  uid
});

export const clearAuth = () => ({
  type: "CLEAR_AUTH"
});
